import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgEyecreamGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M24.046 29.887a8.886 8.886 0 0 0 7.01-3.406l.296-.39-.296-.388a8.886 8.886 0 0 0-7.01-3.406 8.886 8.886 0 0 0-7.01 3.406l-.297.389.297.39a8.886 8.886 0 0 0 7.01 3.405Zm0-6.033c1.185 0 2.27.973 2.27 2.238 0 1.265-.986 2.238-2.27 2.238s-2.271-.973-2.271-2.238c0-1.265.987-2.238 2.271-2.238Zm5.727 2.238c-.79.973-1.876 1.654-2.962 2.043.395-.584.69-1.265.69-2.043 0-.778-.295-1.46-.69-2.043 1.086.389 2.172 1.167 2.962 2.043Zm-8.492-2.043c-.395.583-.69 1.265-.69 2.043 0 .778.295 1.46.69 2.043-1.086-.39-2.172-1.167-2.962-2.043.79-.876 1.876-1.654 2.962-2.043Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M33.92 15H14.172C12.987 15 12 15.973 12 17.14v11.87C12 31.25 13.876 33 16.048 33h15.897c2.27 0 4.048-1.849 4.048-3.99V17.14c.099-1.167-.889-2.14-2.073-2.14Zm.888 14.108c0 1.557-1.283 2.822-2.863 2.822H16.048c-1.58 0-2.863-1.265-2.863-2.822v-8.173h21.623v8.173Zm-21.623-9.34V17.14c0-.486.395-.875.888-.875h19.748c.494 0 .889.39.889.875v2.628H13.185Z",
    fill: "currentColor"
  }));
}

export { SvgEyecreamGlyph as default };
